import React from "react";

const TrashSecondaryIcon = React.forwardRef(
  (
    {
      variant = "solid",          
      width,
      height,
      brandColor = "#5062F0",     
      outlineColor = "#D0D3E2",   
      className,
      ...props
    },
    ref
  ) => {
    const isSolid = variant === "solid";
    const w = width ?? (isSolid ? 18 : 17);
    const h = height ?? (isSolid ? 19 : 17);

    return (
      <svg
        ref={ref}
        width={w}
        height={h}
        viewBox={isSolid ? "0 0 18 19" : "0 0 17 17"}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        {isSolid ? (
          <>
            <rect x="3" y="5" width="12" height="12" fill={brandColor} />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.22207 2.41667C6.96017 2.41667 6.71059 2.50793 6.52783 2.66814C6.34534 2.8281 6.24429 3.04354 6.24429 3.26667V4.11667H11.7554V3.26667C11.7554 3.04354 11.6544 2.8281 11.4719 2.66814C11.2891 2.50793 11.0395 2.41667 10.7776 2.41667H7.22207ZM13.3554 4.11667V3.26667C13.3554 2.6632 13.0818 2.0859 12.5975 1.66138C12.1135 1.2371 11.4587 1 10.7776 1H7.22207C6.54098 1 5.88619 1.2371 5.40216 1.66138C4.91785 2.0859 4.64429 2.6632 4.64429 3.26667V4.11667H1.8C1.35817 4.11667 1 4.4338 1 4.825C1 5.2162 1.35817 5.53333 1.8 5.53333H1.97763V15.7333C1.97763 16.3368 2.25119 16.9141 2.73549 17.3386C3.21952 17.7629 3.87432 18 4.5554 18H13.4443C14.1254 18 14.7802 17.7629 15.2642 17.3386C15.7485 16.9141 16.0221 16.3368 16.0221 15.7333V5.53333H16.2C16.6418 5.53333 17 5.2162 17 4.825C17 4.4338 16.6418 4.11667 16.2 4.11667H13.3554ZM3.57763 5.53333V15.7333C3.57763 15.9565 3.67867 16.1719 3.86116 16.3319C4.04393 16.4921 4.2935 16.5833 4.5554 16.5833H13.4443C13.7062 16.5833 13.9558 16.4921 14.1385 16.3319C14.321 16.1719 14.4221 15.9565 14.4221 15.7333V5.53333H3.57763Z"
              fill="#FFFFFF"
              stroke="#FFFFFF"
              strokeWidth="0.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        ) : (
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.85307 1.41667C6.60164 1.41667 6.36205 1.50793 6.1866 1.66814C6.0114 1.8281 5.9144 2.04354 5.9144 2.26667V3.11667H11.2051V2.26667C11.2051 2.04354 11.1081 1.8281 10.9329 1.66814C10.7574 1.50793 10.5178 1.41667 10.2664 1.41667H6.85307ZM12.7411 3.11667V2.26667C12.7411 1.6632 12.4785 1.0859 12.0135 0.661381C11.5489 0.237097 10.9203 0 10.2664 0H6.85307C6.19923 0 5.57062 0.237097 5.10595 0.661381C4.64102 1.0859 4.3784 1.6632 4.3784 2.26667V3.11667H1.64788C1.22373 3.11667 0.879883 3.4338 0.879883 3.825C0.879883 4.2162 1.22373 4.53333 1.64788 4.53333H1.8184V14.7333C1.8184 15.3368 2.08102 15.9141 2.54595 16.3386C3.01062 16.7629 3.63923 17 4.29307 17H12.8264C13.4803 17 14.1089 16.7629 14.5735 16.3386C15.0385 15.9141 15.3011 15.3368 15.3011 14.7333V4.53333H15.4719C15.896 4.53333 16.2399 4.2162 16.2399 3.825C16.2399 3.4338 15.896 3.11667 15.4719 3.11667H12.7411ZM3.3544 4.53333V14.7333C3.3544 14.9565 3.4514 15.1719 3.6266 15.3319C3.80205 15.4921 4.04164 15.5833 4.29307 15.5833H12.8264C13.0778 15.5833 13.3174 15.4921 13.4929 15.3319C13.6681 15.1719 13.7651 14.9565 13.7651 14.7333V4.53333H3.3544Z"
            fill={outlineColor}
          />
        )}
      </svg>
    );
  }
);

export default React.memo(TrashSecondaryIcon);
